import { render, staticRenderFns } from "./NotificationMetadata.vue?vue&type=template&id=3f9d8b08"
import script from "./NotificationMetadata.vue?vue&type=script&lang=js"
export * from "./NotificationMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports